
import React from 'react'
import Nav from '../Global/Nav'
import Footer from '../Global/Footer'
import ContactHero from './ContactHero'
import ContactForm from '../Global/ContactForm'

const ContactPage = () => {
  return (
    <>
    <Nav />
    <ContactHero />
    <ContactForm />
    <Footer />
    </>
  )
}

export default ContactPage